import { render, staticRenderFns } from "./PidReport.vue?vue&type=template&id=c84504d4&scoped=true"
import script from "./PidReport.vue?vue&type=script&lang=js"
export * from "./PidReport.vue?vue&type=script&lang=js"
import style0 from "./PidReport.vue?vue&type=style&index=0&id=c84504d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84504d4",
  null
  
)

export default component.exports